import { motion } from "framer-motion";
import { useState } from "react";

export default function Portfolio() {
  const [selectedCategory, setSelectedCategory] = useState("all");

  const projects = [
    {
      id: 1,
      title: "Modern Residential Setup",
      category: "residential",
      image: "../../assets/portfolio/modern.jpg",
      savings: "Pkr :45,000/year",
    },
    {
      id: 2,
      title: "Commercial Complex",
      category: "commercial",
      image: "../../assets/portfolio/commercial.jpg",
      savings: "Pkr :2,50,000/year",
    },
    {
      id: 3,
      title: "Agricultural Farm",
      category: "agricultural",
      image: "../../assets/portfolio/agricultural.jpg",
      savings: "Pkr :80,000/year",
    },
    {
      id: 4,
      title: "Smart Home Integration",
      category: "residential",
      image: "../../assets/portfolio/smart-home.jpg",
      savings: "Pkr :50,000/year",
    },
    {
      id: 5,
      title: "Industrial Plant",
      category: "commercial",
      image: "../../assets/portfolio/industrial.jpg",
      savings: "Pkr :5,00,000/year",
    },
    {
      id: 6,
      title: "Community Solar Project",
      category: "agricultural",
      image: "../../assets/portfolio/community-solar.png",
      savings: "Pkr :3,00,000/year",
    },
  ];

  const categories = [
    { id: "all", label: "All Projects" },
    { id: "residential", label: "Residential" },
    { id: "commercial", label: "Commercial" },
    { id: "agricultural", label: "Agricultural" },
  ];

  const filteredProjects =
    selectedCategory === "all"
      ? projects
      : projects.filter((p) => p.category === selectedCategory);

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.1 },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, scale: 0.8 },
    visible: { opacity: 1, scale: 1, transition: { duration: 0.5 } },
  };

  return (
    <>
   
   
    <section
  id="portfolio"
  className="py-20 bg-gradient-to-b from-black to-gray-900/30"
  aria-label="Solar Panel Projects in Sukkur" style={{
          backgroundImage: `linear-gradient(135deg, rgba(0,0,0,0.7) 0%, rgba(22,163,74,0.1) 100%), 
                            url('../../assets/s1.jpg')`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundAttachment: "fixed",
        }}
>
  <div className="max-w-7xl mx-auto px-6">

    {/* SEO Heading */}
    <div className="text-center mb-16">
      <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
        Solar Panel Installation Projects in Sukkur
      </h2>

      <p className="text-white/60 text-lg max-w-2xl mx-auto">
        Explore our completed solar panel installations in Sukkur, Rohri & Khairpur. 
        Residential, commercial and agricultural solar projects with real savings.
      </p>
    </div>

    {/* Projects */}
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {filteredProjects.map((project) => (
        <div key={project.id} className="group relative rounded-2xl overflow-hidden bg-slate-900">

          {/* Image */}
          <img
            src={project.image}
            alt={`${project.title} solar installation in Sukkur`}
            className="w-full h-64 object-cover"
            loading="lazy"
          />

          {/* Content */}
          <div className="p-6">
            <p className="text-sm text-orange-400 capitalize">
              {project.category} solar project
            </p>

            <h3 className="text-lg font-bold text-white">
              {project.title} – Sukkur
            </h3>

            <p className="text-white/60 text-sm mt-2">
              Annual savings: {project.savings}
            </p>

            <a
              href="tel:+923337111075"
              className="inline-block mt-4 text-orange-400 font-semibold"
            >
              📞 Get Similar Installation
            </a>
          </div>
        </div>
      ))}
    </div>

    {/* CTA */}
    <div className="mt-16 text-center">
      <h3 className="text-xl text-white mb-4">
        Looking for Solar Panels in Sukkur?
      </h3>

      <a
        href="https://wa.me/923337111075"
        target="_blank"
        className="px-8 py-3 bg-orange-500 text-black font-bold rounded-lg"
      >
        💬 Get Free Consultation on WhatsApp
      </a>
    </div>

  </div>
</section>
     </>
  );
}
